import { fetchApi } from '../../../lib/fetchApi';

type ShareIndicatorPayload = {
  to: string;
  subject: string;
  body: string;
  file: Blob;
  filename?: string;
};


export const shareIndicator = async ({
  to,
  subject,
  body,
  file,
  filename = 'dashboard.pdf',
}: ShareIndicatorPayload): Promise<void> => {

  const formData = new FormData();

  formData.append("destinationAddressEmail", to);
  formData.append("subject", subject);
  formData.append("body", body);
  formData.append("pdfName", filename);
  formData.append("file", file, filename);

  await fetchApi.post('/surveys/sendEmail', formData);
};

